import React from 'react';
import { Auth0Provider } from '@auth0/auth0-react';
export var Auth0WrapperProvider = function (_a) {
    var domain = _a.domain, clientId = _a.clientId, redirectUri = _a.redirectUri, children = _a.children;
    return (React.createElement(Auth0Provider, { domain: domain, clientId: clientId, redirectUri: redirectUri }, children));
};
//# sourceMappingURL=auth0-provider.js.map